<template>
  <div class="mygamebar_content">
    <ul class="list" v-if="index == 1">
      <li class="item" v-for="(item, index) in list" :key="index">
        <div class="info">
          <div class="left">
            <img
              :src="item.icon"
              alt=""
              class="img"
              @click="
                $router.push({
                  path: '/gameDetails',
                  query: {
                    id: item.gameID,
                  },
                })
              "
            />
            <div class="gameinfo2">
              <p>{{ item.gameName }}</p>
            </div>
          </div>
          <div class="right">
            <div
              @click="
                $router.push({
                  name: 'Pay',
                  params: {
                    id: item.gameID,
                    icon: item.icon,
                    name: item.gameName,
                  },
                })
              "
            >
              充值
            </div>
            <div>启动</div>
          </div>
        </div>
        <div
          class="message"
          @click="$router.push({ path: '/gift', query: { id: item.gameID } })"
        >
          <div class="left">
            <img src="../../assets/images/gift.png" alt="" />
            <p class="title">礼包</p>
            <p>{{ item.gift }}</p>
          </div>
          <van-icon name="arrow" class="right" />
        </div>
        <div
          class="message"
          @click="
            $router.push({
              path: '/announcementList',
              query: { id: item.gameID },
            })
          "
        >
          <div class="left">
            <img src="../../assets/images/laba.png" alt="" />
            <p class="title">公告</p>
            <p>{{ item.announcement }}</p>
          </div>
          <van-icon name="arrow" class="right" />
        </div>
      </li>
      <li v-if="!list.length > 0" class="nogame">
        暂无内容
      </li>
    </ul>
    <ul class="list" v-else>
      <li class="item" v-for="(item, index) in list" :key="index">
        <div class="info">
          <div class="left">
            <img
              :src="item.icon"
              alt=""
              class="img"
              @click="
                $router.push({
                  path: '/gameDetails',
                  query: {
                    id: item.gameID,
                  },
                })
              "
            />
            <div class="gameinfo2">
              <p>{{ item.gameName }}</p>
            </div>
          </div>
          <div class="right">
            <div>下载</div>
          </div>
        </div>
        <div
          class="message"
          @click="$router.push({ path: '/gift', query: { id: item.gameID } })"
        >
          <div class="left">
            <img src="../../assets/images/gift.png" alt="" />
            <p class="title">礼包</p>
            <p>{{ item.gift }}</p>
          </div>
          <van-icon name="arrow" class="right" />
        </div>
        <div
          class="message"
          @click="
            $router.push({
              path: '/announcementList',
              query: { id: item.gameID },
            })
          "
        >
          <div class="left">
            <img src="../../assets/images/laba.png" alt="" />
            <p class="title">公告</p>
            <p>{{ item.announcement }}</p>
          </div>
          <van-icon name="arrow" class="right" />
        </div>
      </li>
      <li v-if="!list.length > 0" class="nogame">
        暂无内容
      </li>
    </ul>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
export default {
  props: {
    index: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    console.log(12312312);
    if (!this.$cookies.get("access_token")) return;
    if (this.index == 1) {
      if (this.$store.state.userPlaygame.length > 0) {
        this.list = this.$store.state.userPlaygame;
      } else {
        this.getList();
      }
    } else {
      if (this.$store.state.userFocusgame.length > 0) {
        this.list = this.$store.state.userFocusgame;
      } else {
        this.getList();
      }
    }
  },
  methods: {
    getList() {
      let data = {
        gid: "100682",
        pid: "100",
        mid: "10000",
        p_mid: "1",
        device_id: "00e7efa241dae8842c8286cf69508e9c",
        client: "h5",
        client_id: "00e7efa241dae8842c8286cf69508e9c",
        tm: comTool.getTm(),
        access_token: this.$cookies.get("access_token"),
        uname: this.$cookies.get("uname"),
      };
      data.sign = comTool.querySort(data);
      if (this.index == 1) {
        apiFun.UserPlayedGame(data).then((res) => {
          this.list = res.data.playingGame;
          this.$store.commit("setUserplaygame", res.data.playingGame);
          // console.log(this.$store.state.userPlaygame);
        });
      } else {
        apiFun.UserFocusGame(data).then((res) => {
          this.list = res.data.likingGame;
          this.$store.commit("setUserfocusgame", res.data.likingGame);
        });
      }
    },
  },
  watch: {
    index() {
      if (this.index == 1) {
        this.list = []
        if (this.$store.state.userPlaygame.length > 0) {
          this.list = this.$store.state.userPlaygame;
        } else {
          this.getList();
        }
      } else {
        this.list = []
        if (this.$store.state.userFocusgame.length > 0) {
          this.list = this.$store.state.userFocusgame;
        } else {
          this.getList();
        }
      }
    },
  },
};
</script>

<style lang="less"  scoped>
.mygamebar_content {
  margin-top: 3vw;
  .list {
    .nogame{
      height: 100vw;
      font-size: 4vw;
      text-align: center;
    }
    .item {
      height: 35.3333vw;
      background: #fff;
      border-radius: 3vw;
      overflow: hidden;
      margin-bottom: 3vw;
      .info {
        margin: 2.5vw;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          text-align: left;

          .img {
            width: 14.6667vw;
            height: 14.6667vw;
            border-radius: 3vw;
            margin-right: 2vw;
          }
          .gameinfo {
            :first-child {
              font-size: 4vw;
              font-weight: 600;
            }
            :last-child {
              font-size: 2.5vw;
              color: #666;
              margin-top: 1vw;
            }
          }
          .gameinfo2 {
            :first-child {
              font-size: 4vw;
              font-weight: 600;
              height: 10vw;
            }
          }
        }
        .right {
          margin-right: 3vw;
          color: #ff961c;
          div {
            width: 13.3333vw;
            height: 6.1333vw;
            line-height: 6.1333vw;
            border: 0.3vw solid #ff961c;
            border-radius: 1vw;
            font-size: 2vw;
          }
          :first-child {
            margin-bottom: 1.5vw;
          }
        }
      }
      .message {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 3vw;
        .left {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-left: 2.5vw;
          font-size: 3vw;
          img {
            width: 2.9333vw;
            height: 2.9333vw;
          }
          .title {
            margin: 0 3vw 0 2vw;
          }
        }
        .right {
          font-size: 3vw;
          color: #666;
          margin-right: 5.5vw;
          font-weight: 600;
        }
      }
    }
  }
}
</style>